import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { ApiUrlService } from '../common/api-url.service';
import { DOCUMENT } from '@angular/common';
import { MetaTagsInfoInterface } from '@core/interfaces/meta-tags-info.interface';

@Injectable({
  providedIn: 'root'
})
export class ApiMetaTagsService {
  private apiUrl: string = this.apiUrlService.getApiUrl() + 'client/get-meta-tags';

  constructor(private httpClient: HttpClient,
              private apiUrlService: ApiUrlService,
              @Inject(DOCUMENT) private document: Document) {
  }

  getMetaTags(slug?: string): Observable<MetaTagsInfoInterface> {
    if (!slug) {
      slug = this.document.location.pathname;
    }
    if (slug.includes('?')) {
      slug = slug.split('?')[0];
    }
    while (slug.charAt(0) === '/') {
      slug = slug.substring(1);
    }

    const url = this.apiUrl + '?pageUrl=' + slug;
    return this.httpClient.get<MetaTagsInfoInterface>(url);
  }


}
